import {UIModuleV2} from '@gongxigames/framework/slotV2/baseClasses/uiModuleV2/UiModuleV2';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {Store} from '@gongxigames/framework/core/fragments/store';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {$UIMainScreenUi, UIMainScreenUiProps} from './components/UIMainScreenUi';
import {BetSelectActions} from './components/BetSelect';
import {Container} from 'pixi.js';
import {ReelsSpeedLevel} from '@gongxigames/framework/slotV2/types';
import {inject} from '@gongxigames/framework/core/installer';
import {CoreDI} from '@gongxigames/framework/core/configs';
import { SlotSettings} from '@gongxigames/framework/slot';
import {uiMainScreenEmitter} from './UIMainScreenEmitter';
import {SignalEventEmitterWrapper} from '@gongxigames/framework/core/services/strictEventEmitter/SignalEventEmitterWrapper';
import {specialInfoZoneStore} from '@gongxigames/framework/slotV2/services/SpecialInfoZone/specialInfoZoneStore';
import {uiElementsStore} from '@gongxigames/framework/slotV2/ui/services/UIElementsStates/uiElementsStore';

export class UIMainScreenModule extends UIModuleV2 {
    public static NAME = 'UIMainScreenModule';
    public static layer = LAYERS.KEYPAD;

    // TODO convert to signals/move to store
    @inject(CoreDI.Settings)
    protected _settings!: SlotSettings;

    private readonly moduleEmitter = new SignalEventEmitterWrapper(uiMainScreenEmitter, {signal: this.abortSignal});

    public container = new Container();

    onInit(): void {
        const bottomPanel = $UIMainScreenUi(this.getProps()) as Container;

        this.container.addChild(bottomPanel);
    }

    onSetupEvents(): void {
        this.emitter.on('Game.command.WinMeter.COUNT_UP', (data) => this.moduleEmitter.emitAsync('COUNT_UP', data));
        this.emitter.on('Game.command.WinMeter.STOP_AFTER_SHOWING_FINAL_VALUE', data => this.moduleEmitter.emit('STOP_AFTER_SHOWING_FINAL_VALUE', data));
        this.emitter.on('Game.command.WinMeter.STOP_FINAL_VALUE_TIMER', () => this.moduleEmitter.emit('STOP_FINAL_VALUE_TIMER'));
        this.emitter.on('Game.command.WinMeter.SET_VALUE', (data) => this.moduleEmitter.emit('SET_VALUE', data));
        this.emitter.on('Game.command.WinMeter.SNAP_TO_FINAL_VALUE', () => this.moduleEmitter.emit('SNAP_TO_FINAL_VALUE'));
        this.emitter.on('Game.command.WinMeter.STOP', () => this.moduleEmitter.emit('STOP'));

        this.emitter.on('UI.bet.hide', this.onHideBetPanel.bind(this));
        this.emitter.on('UI.bet.show', this.onShowBetPanel.bind(this));

        this.moduleEmitter.on('PRESSED_MENU', () => this.emitter.emit('UI.command.menu'));
        this.moduleEmitter.on('PRESSED_TURBO', this.onTurboClicked.bind(this));
        this.moduleEmitter.on('PRESSED_AUTOPLAY_OPTIONS', this.onAutoplayOptions.bind(this));
        this.moduleEmitter.on('PRESSED_BET_CHANGE', this.onBetChange.bind(this));
        this.moduleEmitter.on('PRESSED_BET_SELECT', this.onBetShowPopup.bind(this));
        this.moduleEmitter.on('PRESSED_SOUND', () => this.emitter.emit('UI.sounds.toggle'));
    }

    private getProps(): UIMainScreenUiProps {
        const soundEnabled = Store.computed(() => !slotStore.slot_soundMuted.value);
        const showAutoSpinButton = Store.computed(() => !slotStore.isAutoplay.value && !this._settings.get('autoSpinDisabled'));
        const showAutoSpinOnButton = Store.computed(() => slotStore.isAutoplay.value && !this._settings.get('autoSpinDisabled'));
        const showTurboModeButton = Store.computed(() => !this._settings.get('turboModeDisabled'));
        const bottomPanelOffset = Store.computed(()=> {
            const {numberOfRows, blackPanelHeight, position} = specialInfoZoneStore.values();

            return position === 'top' ? 0 : -(numberOfRows * blackPanelHeight);
        });

        return {
            win: 36000,
            balance: slotStore.slot_ui_label_balance,
            betCurrent: slotStore.slot_bet,
            betFormatted: slotStore.slot_betFormatted,
            betList: slotStore.slot_betList,
            turboLevel: slotStore.reelsSpeedLevel,
            soundEnabled,
            showTurboModeButton,
            showAutoSpinButton,
            showAutoSpinOnButton,
            bottomPanelOffset
        };
    }

    protected onHideBetPanel(): void {
        uiElementsStore.batchUpdate({bet_panel_hidden: true});
    }

    protected onShowBetPanel(): void {
        uiElementsStore.batchUpdate({bet_panel_hidden: false});
    }

    private onTurboClicked(): void {
        this.emitter.emit('UI.turboBtn.pressed');

        const nextSpeedLevel = slotStore.reelsSpeedLevel.peek();
        const soundName = nextSpeedLevel === ReelsSpeedLevel.normal ? 'turbooff' : 'turboon';

        slotStore.soundPlayer.value?.play(soundName);
    }

    private onAutoplayOptions(): void {
        slotStore.soundPlayer.value?.play('buttonclick');

        if (slotStore.isAutoplay.value) {
            this.emitter.emit('UI.stopAutoplayButton.pressed');
        } else {
            this.emitter.emit('UI.autoplayButton.pressed');
        }
    }

    private onBetChange(action: BetSelectActions): void {
        if (action === 'increase') {
            this.emitter.emit('UI.bet.increase');
            slotStore.soundPlayer.value?.play('betbuttonup');
        } else {
            this.emitter.emit('UI.bet.decrease');
            slotStore.soundPlayer.value?.play('betbuttondown');
        }
    }

    private onBetShowPopup(): void {
        slotStore.soundPlayer.value?.play('openuipopup');
        this.emitter.emit('UI.showBetSelectPopup');
    }
}